import { t } from 'i18next';

import { type Brand } from '@growtherapy/tailwind/react';

import { setDefaultFavicon, setTitle } from '../../metadata';

/**
 * Sets the default title for the waiting room
 */
export function setDefaultWaitingRoomTitle() {
  setTitle(t('telehealth-core:meta.waitingRoom'));
}

/**
 * Sets the default favicon and title for the waiting room
 */
export function setDefaultWaitingRoomFaviconAndTitle(brand?: Brand) {
  setDefaultFavicon(brand);
  setDefaultWaitingRoomTitle();
}
